import React, { useEffect, useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { axiosGet } from '../services/axios/apiCalls'

function NotFound({ text }) {
  /** COOKIES */
  const [cookies, setCookie, removeCookie] = useCookies(['login-kiwox-cookies']);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const navigate = useNavigate();
  const ReportAutomator110 = "/resources/static/reportautomator/img/report-automator-gris.png";

  const [notFoundMessage, setNotFoundMessage] = useState('')
  const message = query.get("message");

  const checkOnline = async () => {
    try {
      const reponse = await axiosGet('/ping')
      if (reponse) navigate('/'); else throw 'error';
    } catch (error) {
      console.log('not online')
    }
  }

  useEffect(() => {
    if (message == 'ApiError') checkOnline()

    if (message) {
      switch (message) {
        case 'ApiError':
          setNotFoundMessage('Ha ocurrido un error externo, por favor intente más tarde');
          break;
        case 'NotFound':
          setNotFoundMessage('El recurso solicitado no existe o no se encontró');
          break;
        case 'Unauthorized':
          setNotFoundMessage('No tienes permisos para acceder a esta página');
          break;
        case 'Forbidden':
          setNotFoundMessage('Acceso denegado');
          break;
        case 'SessionExpired':
          setNotFoundMessage('Tu sesión ha expirado, por favor inicia sesión nuevamente');
          break;
        case 'InvalidToken':
          setNotFoundMessage('Token inválido, por favor inicia sesión');
          break;
        case 'BadRequest':
          setNotFoundMessage('La solicitud es incorrecta o está incompleta');
          break;
        case 'ServerError':
          setNotFoundMessage('Error interno del servidor, intenta más tarde');
          break;
        case 'Timeout':
          setNotFoundMessage('La solicitud tardó demasiado en responder, intenta nuevamente');
          break;
        default:
          setNotFoundMessage(text || 'Página no encontrada');
          break;
      }
    } else {
      setNotFoundMessage(text || 'Página no encontrada')
    }
  }, []);

  return (
    <div className="bg-login">
      <Container className="d-flex justify-content-center pt-5" component="main">
        <Box className="kiwox-panel shadow d-flex flex-column align-items-center p-4 w-25">
          <div className="pb-4">
            <img src={ReportAutomator110} alt="report-logo" />
          </div>
          <div>
            <Typography className="center-elements" variant="body1">{notFoundMessage}</Typography>
          </div>
        </Box>
      </Container>

    </div>
  );
}

export default NotFound;